/**
 * Generates a hash code for a given string. HashCode matches OpenJDK's String#hashCode implementation, from here:
 * http://hg.openjdk.java.net/jdk7u/jdk7u6/jdk/file/8c2c5d63a17e/src/share/classes/java/lang/String.java#l1445
 *
 * @param a - The string to generate a hash code for.
 * @returns The hash code for the given string.
 */
export const hashCode = (a: string) =>
  a
    .split('')
    .map((c) => c.charCodeAt(0))
    .reduce((hash, char) => (31 * hash + char) | 0, 0);

/**
 * Generates a hash code for a given instance ID. uses '\0' as a separator
 * between the space and external ID. This is used to ensure that the hash code is unique
 * for the given instance ID. and  '\0' is not a valid character in a space or external ID.
 *
 * @param externalId - The external ID of the instance.
 * @param space - The space of the instance.
 * @returns The hash code for the given instance ID which is unique for the given space and external ID.
 */
export const hashCodeForInstanceId = (
  externalId: string,
  space: string
): number => hashCode(`${space}\0${externalId}`);
